import { render } from "./testgpt.vue?vue&type=template&id=0282618a"
import script from "./testgpt.vue?vue&type=script&lang=js"
export * from "./testgpt.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tony/argon2/vue-argon-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__